import * as React from 'react';
import styled from 'styled-components';
import Radio, { IRadioOptionsProps } from './Radio';

// tslint:disable-next-line:variable-name
const SRadioSection = styled.section(({}) => ({
  display: 'flex',
  flexDirection: 'column',
}));

const SRadioButtonText = styled.div(
  ({ theme }) => `
    font-size: ${theme.font.size.smallMedium};
    font-weight: ${theme.font.weight.normal};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.34;
    letter-spacing: normal;
    text-align: left;
    color: ${theme.colors.grayLight2};
    margin-bottom: ${theme.spacing.large}px;
    max-width: 40%;
`
);

// tslint:disable-next-line:variable-name
const SRadio = styled(Radio as any)(({ theme }) => ({
  marginBottom: theme.spacing.medium,
})) as unknown as new <T>() => Radio<T>;

// tslint:disable-next-line:no-empty-interface
interface IRadioSectionProps<T> {
  name: string;
  radioOptions: Array<IRadioOptionsProps<T>>;
  value: T;
  onChange: (value: T, name: string) => void;
  dataAt: string;
  className?: string;
}

interface IRadioSectionState {
  isSelected: boolean;
}

export class RadioSection<T> extends React.Component<IRadioSectionProps<T>, IRadioSectionState> {
  public state: IRadioSectionState = {
    isSelected: false,
  };

  public static defaultProps = {
    value: null,
    className: '',
  };

  private handleOnClick = (value: T) => {
    this.props.onChange(value, this.props.name);
  };

  public render() {
    return (
      <SRadioSection className={this.props.className} data-at={this.props.dataAt}>
        <SRadioButtonText>{this.props.children}</SRadioButtonText>
        <div>
          {this.props.radioOptions.map((radioOption, index) => (
            <SRadio<T>
              key={index}
              {...radioOption}
              onClick={this.handleOnClick}
              selected={this.props.value === radioOption.value}
            />
          ))}
        </div>
      </SRadioSection>
    );
  }
}
